import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { bp } from 'Styles/helpers';
import { rem } from 'polished';
import screen from 'superior-mq';
import handleData from 'Lib/handleData';
import Button from '../../button';
import Container from '../../container';
import Grid from '../../grid';
import UnstyledButton from '../../unstyled-button';

const gridStyles = `
  ${screen.below(bp.mobileSm, `
    grid-gap: 10px;
  `)};
`;

const gridItemStyles = `
  ${screen.above(bp.mobile, `
    &:first-of-type {
      justify-self: end;
    }

    &:last-of-type {
      justify-self: start;
    }
  `)};

  ${screen.below(bp.mobileRealSm, `
    grid-column: 1 / -1;
  `)};
`;

const resendVerification = (e, props) => {
  e.preventDefault();

  handleData('POST', `/v1/users/${props.userId}/verification/email`, {})
    .then(() => {
      props.openModal(null, 'verification');
    })
    .catch(() => {
      props.openModal(null, 'verification-failed');
    });
};

const AccountHero = props => (
  <AccountHeroSection>
    <Container>
      <span>Account Details</span>
      <h1>{props.name}</h1>

      {props.location &&
        <h5>{props.location}</h5>
      }

      <AccountActions cols={2} styles={gridStyles} hasPhoto={!!props.photo}>
        {!props.hideButtons &&
          <Fragment>
            <Grid.Item span={1} styles={gridItemStyles}>
              <AccountButton onClick={(e) => { props.openModal(e, 'account'); }}>Edit Account</AccountButton>
            </Grid.Item>
            <Grid.Item span={1} styles={gridItemStyles}>
              <AccountButton onClick={(e) => { props.openModal(e, 'payment'); }}>Edit Payment Methods</AccountButton>
            </Grid.Item>
          </Fragment>
        }

        {props.photo &&
          <img src={props.photo} alt={`${props.name} avatar`} />
        }
      </AccountActions>

      {!props.verified && !props.hideButtons &&
        <AccountVerified>
          *The e-mail associated with your account has not been
          verified and therefore you have limited access to various
          aspects of this
          website. <VerificationLink onClick={(e) => { resendVerification(e, props); }}>
          Resend a verification e-mail </VerificationLink>.
        </AccountVerified>
      }
    </Container>
  </AccountHeroSection>
);

const AccountHeroSection = styled.section`
  padding: 250px 0 155px;
  text-align: center;

  > span {
    display: block;
    font-size: ${rem(16)};
  }

  h1 {
    margin: 16px 0;
  }

  h5 {
    font-family: ${props => props.theme.sansFont};
    font-size: ${rem(44)};

    ${screen.below(bp.laptopSm, `
      font-size: ${rem(32)};
    `)};

    ${screen.below(bp.mobileSm, `
      font-size: ${rem(25)};
    `)};
  }

  ${screen.below(bp.mobile, `
    padding: 155px 0;
  `)};

  ${screen.below(bp.mobileSm, `
    padding: 80px 0;
  `)};
`;

const AccountActions = styled(Grid)`
  position: relative;
  margin-top: ${props => !props.hasPhoto ? '60px' : '210px'};

  img {
    position: absolute;
    top: -110px;
    left: 50%;
    z-index: -1;
    transform: rotate(10deg) translateX(-50%);

    ${screen.below(bp.mobileSm, `
      top: -55px;
    `)};
  }

  ${css`
    ${props => screen.below(bp.mobileSm, `
      margin-top: ${!props.hasPhoto ? '40px' : '100px'};
    `)}
  `}
`;

const AccountVerified = styled.p`
  margin: 50px auto 0 auto;
  width: 600px;
  max-width: 100%;
  font-size: 1rem;

  ${screen.below(bp.mobileSm, `
    margin-top: 30px;
  `)}
`;

const VerificationLink = styled(UnstyledButton)`
  color: ${props => props.theme.blue};
`;

const AccountButton = styled(Button)`
  ${screen.below(bp.mobile, `
    width: 100%;
    min-width: 100%;
  `)};
`;

/*
  userId prop-type is used in function
  defined outside of the component
 */
AccountHero.propTypes = {
  openModal: PropTypes.func,
  name: PropTypes.string,
  location: PropTypes.string,
  photo: PropTypes.string,
  userId: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
  verified: PropTypes.bool,
  hideButtons: PropTypes.bool,
};

export default AccountHero;
